import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { PinEntryFieldsFourDigits } from '@eika-kortbetjening/pin-code';

import { setNewPin, setNewPinFromAccountId } from '@/react-query/services/pin';

import { CardType, SetPinSession } from '@generated-types';

export interface SetNewPinRequest {
    cardType: CardType;
    cardId: string;
    newPin: PinEntryFieldsFourDigits;
}

export const useSetNewPin = () =>
    useMutation<void, Error, SetNewPinRequest>({
        mutationKey: ['setNewPin'],
        mutationFn: ({ cardType, cardId, newPin }: SetNewPinRequest) => setNewPin(cardType, cardId, newPin),
    });

export interface SetNewPinFromAccountIdRequest {
    newPin: PinEntryFieldsFourDigits;
}

export const useSetNewPinFromAccountId = (
    { accountId }: { accountId: string },
    options?: Omit<
        UseMutationOptions<SetPinSession, Error, SetNewPinFromAccountIdRequest>,
        'mutationFn' | 'mutationKey'
    >,
) =>
    useMutation<SetPinSession, Error, SetNewPinFromAccountIdRequest>({
        ...options,
        mutationKey: ['setNewPin', 'fromAccountId', accountId],
        mutationFn: ({ newPin }: SetNewPinFromAccountIdRequest) => setNewPinFromAccountId(accountId, newPin),
    });
